import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as Redux } from 'react-redux';
import './styles/global.less';
import '@spectrum-css/typography/dist/vars.css';
import '@spectrum-css/typography/dist/index-vars.css';
import { initGlobals } from 'app/stores/editor/config';
import { createStore } from 'app/stores/store';
import { ErrorBoundary, installErrorNotifier } from 'app/utils/error';
import { printVersion } from 'app/utils/version';
import { App } from './views/App';
const Application = () => (React.createElement(ErrorBoundary, null,
    React.createElement(Redux, { store: createStore() },
        React.createElement(StrictMode, null,
            React.createElement(App, null)))));
export const createAnnotelyEditorApp = (container) => {
    if (!container) {
        // eslint-disable-next-line no-console
        console.warn('Element for React root cannot be empty');
        return;
    }
    printVersion();
    initGlobals();
    installErrorNotifier();
    createRoot(container).render(React.createElement(Application, null));
};
